import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { useFeatureFlags } from '../../contexts/FeatureFlagsContext';
import { useUserRole } from '../../hooks/useUserRole';
import { AlertTriangle } from 'lucide-react';

export const DashboardLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const { features } = useFeatureFlags();
  const { isManager } = useUserRole();

  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900">
      {/* Mobile sidebar */}
      <div
        className={`
          fixed inset-0 z-40 lg:hidden
          ${isSidebarOpen ? 'block' : 'hidden'}
        `}
      >
        {/* Backdrop */}
        <div 
          className="fixed inset-0 bg-gray-600/75 transition-opacity"
          onClick={() => setIsSidebarOpen(false)}
        />
        
        {/* Sidebar container */}
        <div className="fixed inset-y-0 left-0 w-full max-w-xs">
          <Sidebar onClose={() => setIsSidebarOpen(false)} />
        </div>
      </div>

      {/* Desktop sidebar */}
      <div className="hidden lg:fixed lg:inset-y-0 lg:flex lg:w-64 lg:flex-col">
        <Sidebar />
      </div>

      {/* Main content */}
      <div className="lg:pl-64 flex flex-col min-h-screen">
        <Header 
          onMenuClick={() => setIsSidebarOpen(true)} 
          isSidebarOpen={isSidebarOpen}
        />
        
        <main className="flex-1 p-4 sm:p-6 lg:p-8">
          <div className="max-w-7xl mx-auto">
            <Outlet />
          </div>
        </main>

        {/* Maintenance Mode Indicator */}
        {isManager && features.maintenanceMode && (
          <div className="fixed bottom-4 right-4 z-50">
            <div className="flex items-center space-x-2 bg-yellow-500 dark:bg-yellow-600 text-white px-4 py-2 rounded-lg shadow-lg">
              <AlertTriangle className="h-4 w-4" />
              <span className="text-sm font-medium">Wartungsmodus aktiv</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};